import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SizeGuide from '../../../SizeGuide/SizeGuide'
import SelectSizePicker from './SelectSizePicker'
import TiledSizePicker from './TiledSizePicker'
import SizesBackInStockForm from './SizesBackInStockForm'

import { by, to, project } from '../../../../utils'
import { getVariantsForType, sortSizeVariantsBySizeAsc } from '../../AttributeSelectorHelpers'

const hasLongValue = attr => !attr.shortValue || attr.shortValue.length > 4

class SizePicker extends Component {
  render() {
    const {
      type,
      combinationsGroupedByType,
      value,
      partNumber,
      breadcrumb,
      categories,
      sizeGuide = false,
      brand,
      isTuMobileLayout
    } = this.props

    const sizeVariants = getVariantsForType(combinationsGroupedByType, value, partNumber)

    sortSizeVariantsBySizeAsc(sizeVariants)

    const isTooLong = sizeVariants
      .map(project.attributes)
      .map(to.filter(by.typeOf(type)))
      .some(to.some(hasLongValue))

    const lastBreadcrumb = breadcrumb.find(by.typeOf('PLP'))
    const categoryId = lastBreadcrumb && parseInt(lastBreadcrumb.id, 10)
    const pimId = categories[categories.length - 1]?.id
    const sizeInfo =
      sizeGuide && (pimId || categoryId)
        ? () => <SizeGuide pimId={pimId} categoryId={categoryId} brand={brand} />
        : () => {}

    const SizePickerComponent = isTooLong ? SelectSizePicker : TiledSizePicker

    return (
      <>
        <SizePickerComponent {...this.props} combinations={sizeVariants} sizeInfo={sizeInfo} />

        <SizesBackInStockForm
          combinations={sizeVariants}
          type={type}
          isShortLabels={!isTooLong}
          isTuMobileLayout={isTuMobileLayout}
        />
      </>
    )
  }
}

SizePicker.propTypes = {
  type: PropTypes.string,
  combinationsGroupedByType: PropTypes.array,
  breadcrumb: PropTypes.array,
  categories: PropTypes.arrayOf({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string
  }),
  isTuMobileLayout: PropTypes.bool
}

SizePicker.defaultProps = {
  breadcrumb: [],
  categories: [],
  isTuMobileLayout: false
}

export default SizePicker
